import { env } from '@/config/env';

/**
 * Google Analytics utility functions
 */

const GA_MEASUREMENT_ID = env.gaMeasurementId || 'G-3062CS6VBW';

// Track page views
export const trackPageView = (path) => {
  if (typeof window !== 'undefined' && window.gtag && GA_MEASUREMENT_ID) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path || window.location.pathname,
    });
  }
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

// Track user engagement
export const trackEngagement = (category, action, label, value) => {
  trackEvent('engagement', {
    event_category: category,
    event_action: action,
    event_label: label,
    value: value
  });
};

// Track form submissions
export const trackFormSubmission = (formName, success = true) => {
  trackEvent('form_submission', {
    form_name: formName,
    success: success
  });
};

// Track outbound links
export const trackOutboundLink = (url) => {
  trackEvent('outbound_link', {
    destination: url
  });
};

// Track course views
export const trackCourseView = (courseId, courseName) => {
  trackEvent('course_view', {
    course_id: courseId,
    course_name: courseName
  });
};

// Track registration steps
export const trackRegistrationStep = (step, stepName) => {
  trackEvent('registration_progress', {
    step: step,
    step_name: stepName
  });
};